import React, { Component } from 'react';
import styles from './styles.scss';

class DashboardHeader extends Component {
  render() {
    const { header, subheader } = this.props;

    return (
      <div className={styles.header}>
        <span>{header}</span>
        {subheader && <span className={styles.subheader}>{subheader}</span>}
      </div>
    );
  }
}

export default DashboardHeader;
